import type { GlobalSearchActionHit } from './global-search.types';

/** Full command list for `>` mode and idle shortcuts (role-filtered at runtime). */
export const GLOBAL_SEARCH_COMMANDS: GlobalSearchActionHit[] = [
  {
    kind: 'action',
    id: 'new-patient',
    label: 'New patient',
    description: 'Register someone new',
    href: '/patients/new',
    icon: 'userPlus',
  },
  {
    kind: 'action',
    id: 'book-appointment',
    label: 'Book appointment',
    description: 'Schedule a visit',
    href: '/appointments/new',
    icon: 'calendar',
  },
  {
    kind: 'action',
    id: 'waiting-room',
    label: 'Waiting room',
    description: 'Open the live floor queue',
    href: '/appointments/waiting-room',
    icon: 'users',
  },
  {
    kind: 'action',
    id: 'calendar',
    label: 'Calendar',
    description: 'Open the appointment calendar',
    href: '/appointments/calendar',
    icon: 'calendar',
  },
  {
    kind: 'action',
    id: 'all-patients',
    label: 'All patients',
    description: 'Browse the patient list',
    href: '/patients',
    icon: 'users',
  },
  {
    kind: 'action',
    id: 'all-appointments',
    label: 'Appointments list',
    description: 'Open the appointment list',
    href: '/appointments/list',
    icon: 'calendar',
  },
  {
    kind: 'action',
    id: 'new-invoice',
    label: 'New invoice',
    description: 'Create a billing invoice',
    href: '/billing/invoices/new',
    icon: 'receipt',
  },
  {
    kind: 'action',
    id: 'all-invoices',
    label: 'All invoices',
    description: 'Open billing invoices',
    href: '/billing/invoices',
    icon: 'receipt',
  },
];

const DOCTOR_HIDDEN = new Set(['new-invoice', 'all-invoices', 'new-patient']);

/**
 * Role-softened command list for the palette.
 */
export function filterCommandsForRole(
  role: string | null | undefined,
  commands: GlobalSearchActionHit[] = GLOBAL_SEARCH_COMMANDS,
): GlobalSearchActionHit[] {
  if (role === 'doctor') {
    return commands.filter((c) => !DOCTOR_HIDDEN.has(c.id));
  }
  return commands;
}

/**
 * Filters commands by optional free-text (label / description).
 */
export function filterCommandsByTerm(
  commands: GlobalSearchActionHit[],
  term: string,
): GlobalSearchActionHit[] {
  const q = term.trim().toLowerCase();
  if (!q) return commands;
  return commands.filter(
    (c) =>
      c.label.toLowerCase().includes(q) ||
      c.description.toLowerCase().includes(q) ||
      c.id.includes(q),
  );
}
